/**
 * i18n Configuration
 *
 * Hybrid approach:
 * - Static UI text: JSON translation files
 * - AI-generated content: Generated in target language
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import nl from './locales/nl.json';
import { teacherHoursEn } from '@/modules/planning/i18n/teacherHours.en';
import { teacherHoursNl } from '@/modules/planning/i18n/teacherHours.nl';
import { groupVideosEn, groupVideosNl } from '@/modules/planning/i18n/groupVideos';
import { staffAddressEn, staffAddressNl } from './staffAddress';

export const supportedLanguages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
] as const;

export type SupportedLanguage = typeof supportedLanguages[number]['code'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en, teacherHours: teacherHoursEn, groupVideos: groupVideosEn, staffAddress: staffAddressEn },
      nl: { translation: nl, teacherHours: teacherHoursNl, groupVideos: groupVideosNl, staffAddress: staffAddressNl },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'teddykids-language',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;

// Helper to get current language for AI prompts
export const getCurrentLanguage = (): SupportedLanguage => {
  return (i18n.language?.split('-')[0] as SupportedLanguage) || 'en';
};

// Helper to get language name for AI prompts
export const getLanguageNameForAI = (): string => {
  const lang = getCurrentLanguage();
  return lang === 'nl' ? 'Dutch' : 'English';
};
